import React from 'react';
import ReactDOM from 'react-dom';
import { UIRouter, hashLocationPlugin, servicesPlugin, UISrefActive, UIView } from '@uirouter/react';
import { Provider as ReduxProvider } from 'react-redux';

import LoginScreen from './Components';



// define states
const app_states = [{ name: 'nologinneeded', url: '/web/insured/home', component: LoginScreen }];

const uiRouterConfigFn = function(router) {
  router.urlService.rules.otherwise(function(_router, _url) {
    const currentState = router.stateService.current.name;
    if (!currentState) {
      router.stateService.go('users', null, { location: false });
    }
    return;
  });
};

ReactDOM.render(
  
    <UIRouter config={uiRouterConfigFn} plugins={[hashLocationPlugin, servicesPlugin]} states={app_states}>
      <div>
        <UISrefActive class="active" />
        <UIView>
          <LoginScreen />
        </UIView>
      </div>
    </UIRouter>,
  document.getElementById('insured_portal_nologinneeded_portlet')
);
